<template>
  <v-sheet>
    <v-label>{{ label ? label : 'Cor' }}</v-label>
    <v-color-picker
      v-model="modelValue"
      :label="label ? label : 'Cor'"
      type="color"
      mode="hexa"
      show-swatches
      :swatches="[
        ['#DCE6E0', '#173042', '#ADADB6', '#253D4E'],
        ['#33CC99', '#E0EFEA', '#67D9D1', '#5D6F7B'],
        ['#0000BA', '#76ADF1', '#5C7FFF', '#3A35C7'],
        ['#595769', '#302D44', '#8EA7FF', '#6B66A3'],
        ['#9999FF', '#007B9A', '#B00020', '#2196F3'],
        ['#A6C4E8', '#046732', '#FB8C00', '#61676A'],
        ['#3D4251', '#E8E8E8', '#F4F4F4', '#E1FFD3'],
        ['#000000', '#FFFFFF', '#CCCCCC', '#DDDDDD']
      ]"
    />
  </v-sheet>
</template>

<script>
  export default {
    name: 'ColorInput',
    props: {
      value: {
        type: String,
        required: false,
      },
      label: {
        type: String,
        default: 'Cor',
      },
      error: {
        type: String,
        required: false,
      },
    },
    emits: ['input'],
    data: function () {
      return {
        modelValue: null,
      }
    },
    watch: {
      modelValue: function (value) {
        this.$emit('input', value)
      },
    },
    mounted: function () {
      this.modelValue = this.value ?? '#FFFFFF'
    },
  }
</script>
